module.exports = __webpack_public_path__ + "media/img/astronauto-blue-83020d6c.png";